module.exports = __webpack_public_path__ + "onboarding7.png";